<template>
    <v-form-item
        name="replyTxt"
        label="文本内容"
        required="请输入"
        @error="handlerError"
    >
        <div
            @mouseup="textAreaKeyupOrMouseup"
            @keyup="textAreaKeyupOrMouseup"
            class="editor-box"
        >
            <div class="tools-bar">
                <v-tip
                    ref="emoji"
                    placement="top"
                    kind="large"
                    clazz="v-reply-txt-panel-emoji"
                >
                    <ul class="emotion-list">
                        <li
                            v-for="(item, index) in faceIndex"
                            :key="index"
                            class="emotion-item"
                        >
                            <v-emotion
                                :text="emotionText(item)"
                                @click="emotionOnClick(index)"
                            />
                        </li>
                    </ul>
                </v-tip>
                <div
                    v-tip:emoji.click
                    class="qq-emotion"
                >
                    <v-icon
                        name="basic_emoji_line"
                        remote
                    />
                </div>
            </div>
            <v-textarea
                ref="vReplyTxtPanelTextarea"
                v-model="currentValue"
                :limit="limit"
                class="v-reply-txt-panel-textarea"
                placeholder="请输入"
                autoheight
            />
        </div>
    </v-form-item>
</template>

<script>
import QQFaceTool from 'src/common/QQFaceTool';
import { WXFaceMap } from '../config/WXFaceConfig';
import errorMixin from '../errorMixin';

export default {
    mixins: [errorMixin],
    props: {
        value: {
            type: Object,
            default: {},
        },
        limit: {
            type: Number,
            default: 300,
        },
    },
    data() {
        // cursorPosition: IE下需要记录光标的位置，否则会在开头位置插入文本
        return {
            currentValue: '',
            faceIndex: WXFaceMap,
            cursorPosition: 0,
        };
    },
    computed: {
        checkConfirm() {
            return !this.currentValue;
        },
    },

    watch: {
        value(val) {
            this.initData();
        },
        currentValue(val) {
            const parsedTxt = QQFaceTool.textToCode(val);
            // 当前为纯文本，故两者内容一致
            this.$emit('input', {
                replyText: parsedTxt,
                // mark说leon说不要了。内容是一样的。
                // replyTextHtml: parsedTxt,
            });
        },
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            this.currentValue = QQFaceTool.codeToText(this.value.replyText || '') || '';
        },
        emotionText(item) {
            if (typeof item.code !== 'undefined') return `[f_${item.code}]`;
            return item.text;
        },
        indexToText(index) {
            let str = '';
            const emotionItem = this.faceIndex[index];
            if (typeof emotionItem !== 'undefined') {
                if (typeof emotionItem.alias !== 'undefined') str = emotionItem.text;
                else if (typeof emotionItem.text !== 'undefined') str = `[${emotionItem.text}]`;
            }
            return str;
        },
        emotionOnClick(index) {
            this.addFace(this.indexToText(index));
        },
        textAreaKeyupOrMouseup() {
            const textArea = this.$refs.vReplyTxtPanelTextarea.$el.children[1];
            this.cursorPosition = this.getCursorPosition(textArea);
        },
        addFace(title) {
            const self = this;
            const textArea = this.$refs.vReplyTxtPanelTextarea.$el.children[1];
            function insertText(obj, str) {
                if (document.selection) {
                    // ie
                    // IE真的很烦，需要的动将光标移到对应位置，不然总是在开头位置插入文本
                    // http://tapd.oa.com/10109441/bugtrace/bugs/view?bug_id=1010109441062446675
                    self.moveCursor(obj, self.cursorPosition);
                    const sel = document.selection.createRange();
                    sel.text = str;
                    //   return sel;
                } else if (typeof obj.selectionStart === 'number' && typeof obj.selectionEnd === 'number') {
                    const startPos = obj.selectionStart;
                    const endPos = obj.selectionEnd;
                    let cursorPos = startPos;
                    const tmpStr = self.currentValue;
                    self.currentValue = tmpStr.substring(0, startPos) + str + tmpStr.substring(endPos, tmpStr.length);
                    cursorPos += str.length;
                    // IE11下，setTimeout设置为0会有问题
                    self.$nextTick(() => {
                        obj.selectionStart = obj.selectionEnd = cursorPos;
                    });
                } else {
                    self.currentValue += str;
                }
                self.cursorPosition += str.length;
            }
            textArea.focus();
            insertText(textArea, title);
        },
        // get输入框中光标cursor位置
        getCursorPosition(node) {
            const el = node;
            let index = 0;

            if (document.selection) {
                // IE Support
                node.focus();
                const Sel = document.selection.createRange();
                if (el.nodeName === 'TEXTAREA') {
                    // textarea
                    const Sel2 = Sel.duplicate();
                    Sel2.moveToElementText(el);
                    index = -1;
                    while (Sel2.inRange(Sel)) {
                        Sel2.moveStart('character');
                        index++;
                    }
                } else if (el.nodeName === 'INPUT') {
                    // input
                    Sel.moveStart('character', -el.value.length);
                    index = Sel.text.length;
                }
            } else if (el.selectionStart || el.selectionStart == '0') {
                // Firefox support
                index = el.selectionStart;
            }
            return index;
        },
        // 移动cursor到特定位置
        moveCursor(obj, index) {
            const target = index != undefined ? index : obj.value.length;
            obj.focus();
            if (document.selection != undefined) {
                // IE
                const sel = obj.createTextRange();
                sel.moveStart('character', target);
                sel.collapse(true);
                sel.select();
            } else if (obj.selectionStart != undefined) {
                obj.selectionStart = obj.selectionEnd = target;
            }
        },
    },
};
</script>

<style lang="less" scoped>
.editor-box{
    display: flex;
    flex-direction: column;
    border: var(--border-normal) solid var(--color-border-normal);
    border-radius: var(--radius-normal);
    background: #fff;
    .tools-bar{
        border-bottom: 1px solid var(--color-divider-normal);
        padding: 4px;

        .qq-emotion {
            width: 16px;
            height: 16px;
            padding: 4px;

            &:hover{
                color: var(--color-link-hover);
            }
        }
    }

    .v-textarea{
        border: 0;
        width: 100%;
        margin-top: 0 !important;
        min-height: 100px;
    }
}
</style>

<style lang="less">
.v-reply-txt-panel-emoji {
    width: 396px;
    padding: 5px;
    .emotion-list {
        .emotion-item {
            display: inline-block;
            margin: 2px;
            width: 20px;
            height: 20px;
            cursor: pointer;
        }
    }
}
</style>
